import { FeedbackModalComponent } from './feedback-modal/feedback-modal.component';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';

import { LayoutComponent } from './layout.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HeaderComponent } from './header/header.component';
import { NavsearchComponent } from './header/navsearch/navsearch.component';
import { OffsidebarComponent } from './offsidebar/offsidebar.component';
import { UserblockComponent } from './sidebar/userblock/userblock.component';
import { UserblockService } from './sidebar/userblock/userblock.service';
import { FooterComponent } from './footer/footer.component';

import { SharedModule } from '../shared/shared.module';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FabButtonComponent } from './fab-button/fab-button.component';
import { ServiceChatModalComponent } from './service-chat-modal/service-chat-modal.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ChatbotButtonComponent } from './chatbot-button/chatbot-button.component';

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        SharedModule,
        FontAwesomeModule
    ],
    providers: [
        UserblockService
    ],
    declarations: [
        LayoutComponent,
        SidebarComponent,
        UserblockComponent,
        HeaderComponent,
        NavsearchComponent,
        OffsidebarComponent,
        FooterComponent,
        FabButtonComponent,
        FeedbackModalComponent,
        ServiceChatModalComponent,
        ChatbotButtonComponent
    ],
    exports: [
        LayoutComponent,
        SidebarComponent,
        UserblockComponent,
        HeaderComponent,
        NavsearchComponent,
        OffsidebarComponent,
        FooterComponent,
        FabButtonComponent,
        FeedbackModalComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
        
})
export class LayoutModule { }
